const WaitingListGraphicRoutes = [
  {
    path: '/grafico-lista-de-espera',
    meta: { title: 'Gráfico Lista de Espera' },
    name: 'WaitingListGraphic',
    component: () => import('@/views/waitinglist/waitinglist-graphic/WaitingList-Graphic.vue')
  }
]

export default WaitingListGraphicRoutes